import { applyMiddleware, combineReducers, createStore } from 'redux';
import {
    userLoginReducer,
    userRegisterReducer,
    userDetailsReducer,
    userUpdateReducer, userListReducer, userPretendChangeReducer, userDeleteReducer,
} from './reducers/userReducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import {
    playerActivityReducer,
    playerCreateReducer,
    playerDeleteReducer,
    playerDetailsReducer,
    playerListReducer, playerLogDatesReducer, playerLogForDateReducer, playerRestartReducer,
    playerUpdateDetailsReducer,
} from './reducers/playerReducers';
import { tagListReducer } from './reducers/tagReducers';
import {
    commercialCreateReducer,
    commercialListReducer,
    commercialDetailReducer,
    commercialUpdateReducer,
    commercialDeleteReducer,
} from './reducers/commercialReducers';
import {
    signalCreateReducer,
    signalDeleteReducer,
    signalDetailsReducer,
    signalListReducer,
    signalUpdateDetailsReducer,
} from './reducers/signalReducers';

import {
    announcementCreateReducer,
    announcementDeleteReducer,
    announcementDetailReducer,
    announcementListReducer,
    announcementUpdateReducer,
} from './reducers/announcementReducers';
import {
    campaignCreateReducer,
    campaignDeleteReducer,
    campaignDetailReducer,
    campaignListReducer,
    campaignUpdateReducer,
} from './reducers/campaignReducers';
import {settingsListReducer, settingsUpdateReducer} from "./reducers/settingsReducers";
import {programmeListReducer} from "./reducers/programmeReducers";
import {getPlayerFileReducer} from "./reducers/downloadReducers";
import {
    videoCreateReducer, videoDeleteReducer,
    videoDetailsReducer,
    videoListReducer,
    videoUpdateDetailsReducer
} from "./reducers/videoReducer";
import {
    videoCampaignCreateReducer, videoCampaignDeleteReducer,
    videoCampaignDetailReducer,
    videoCampaignListReducer, videoCampaignUpdateReducer
} from "./reducers/videoCampaignReducers";
import {
    videoPlayerCreateReducer,
    videoPlayerDeleteReducer,
    videoPlayerDetailsReducer,
    videoPlayerListReducer,
    videoPlayerLogDatesReducer,
    videoPlayerLogForDateReducer,
    videoPlayerRestartReducer,
    videoPlayerUpdateDetailsReducer
} from "./reducers/videoPlayerReducers";
import {listPlayerActivities} from "./actions/playerActions";
import {videoProgrammeListReducer} from "./reducers/videoProgrammeListReducer";

const reducer = combineReducers({
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdate: userUpdateReducer,
    userList: userListReducer,
    userDelete: userDeleteReducer,
    userPretendChange: userPretendChangeReducer,
    playerList: playerListReducer,
    playerCreate: playerCreateReducer,
    playerDetails: playerDetailsReducer,
    playerUpdateDetails: playerUpdateDetailsReducer,
    playerDelete: playerDeleteReducer,
    playerLogDates: playerLogDatesReducer,
    playerLogForDate: playerLogForDateReducer,
    playerRestart: playerRestartReducer,
    playerActivities: playerActivityReducer,
    videoPlayerList: videoPlayerListReducer,
    videoPlayerCreate: videoPlayerCreateReducer,
    videoPlayerDetails: videoPlayerDetailsReducer,
    videoPlayerUpdateDetails: videoPlayerUpdateDetailsReducer,
    videoPlayerDelete: videoPlayerDeleteReducer,
    videoPlayerLogDates: videoPlayerLogDatesReducer,
    videoPlayerLogForDate: videoPlayerLogForDateReducer,
    videoPlayerRestart: videoPlayerRestartReducer,
    tagList: tagListReducer,
    commercialCreate: commercialCreateReducer,
    commercialList: commercialListReducer,
    commercialDetails: commercialDetailReducer,
    commercialUpdateDetails: commercialUpdateReducer,
    commercialDelete: commercialDeleteReducer,
    signalCreate: signalCreateReducer,
    signalList: signalListReducer,
    signalDetails: signalDetailsReducer,
    signalUpdateDetails: signalUpdateDetailsReducer,
    signalDelete: signalDeleteReducer,
    videoCreate: videoCreateReducer,
    videoList: videoListReducer,
    videoDetails: videoDetailsReducer,
    videoUpdateDetails: videoUpdateDetailsReducer,
    videoDelete: videoDeleteReducer,
    announcementCreate: announcementCreateReducer,
    announcementDelete: announcementDeleteReducer,
    announcementDetails: announcementDetailReducer,
    announcementList: announcementListReducer,
    announcementUpdateDetails: announcementUpdateReducer,
    campaignList: campaignListReducer,
    campaignCreate: campaignCreateReducer,
    campaignDetails: campaignDetailReducer,
    campaignUpdate: campaignUpdateReducer,
    campaignDelete: campaignDeleteReducer,
    videoCampaignList: videoCampaignListReducer,
    videoCampaignCreate: videoCampaignCreateReducer,
    videoCampaignDetails: videoCampaignDetailReducer,
    videoCampaignUpdate: videoCampaignUpdateReducer,
    videoCampaignDelete: videoCampaignDeleteReducer,
    settingsList: settingsListReducer,
    settingsUpdate: settingsUpdateReducer,
    programmeList: programmeListReducer,
    videoProgrammeList: videoProgrammeListReducer,
    downloadPlayer: getPlayerFileReducer,
});

const userInfoFromStorage = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null;

const initialState = {
    userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
